jQuery(document).ready(function ($) {
    window.arise_pc_state = window.arise_pc_state || {
        services: [],
        current_response: false,
        next_question: -1,
        all_services: [],
    };

    const state = window.arise_pc_state;

    window.arise_pc_get_service_name = window.arise_pc_get_service_name || function (id) {
        const tile = $('#' + id);
        return tile.length ? tile.attr('title') : id;
    };

    const getServiceName = window.arise_pc_get_service_name;

    $.fn.toggleService = function () {
        this.toggleClass('selected');

        dataLayer.push({
            event: 'service_selected',
            service_name: this.find('span').text()
        })

        const service_id = this.attr('id');

        const next_button = this.parent().parent().next().find('.pc-next');

        if (state.services.includes(service_id)) {
            state.services = state.services.filter(function (item) {
                return item !== service_id;
            });

            if (state.services.length === 0) {
                next_button.addClass('disabled');
            }
        }
        else {
            state.services.push(service_id);

            next_button.removeClass('disabled');
        }

        this.closest('.pricing-calculator').attr('data-services', state.services.join(','));

        return this;
    }

    $.fn.toggleAnswer = function () {
        const isMultipleChoice = this.parent().hasClass('pricing-calculator__answers--multiple-choice');

        if (isMultipleChoice) {
            this.toggleClass('selected');
        } else {
            this.siblings().removeClass('selected');
            this.toggleClass('selected');
        }

        const service_id = state.services[0];
        const next_button = this.parent().parent().next().find('.pc-next');

        dataLayer.push({
            event: 'answer_selected',
            answer_name: this.find('span').text()
        });

        if (isMultipleChoice) {
            const selectedIndices = [];
            this.parent().find('.pricing-calculator__answer').each(function (i) {
                if ($(this).hasClass('selected')) {
                    selectedIndices.push(i);
                }
            });

            state.current_response = selectedIndices.length > 0
                ? `${service_id}:${state.next_question}:${selectedIndices.join(',')}`
                : false;
        } else {
            state.current_response = this.hasClass('selected')
                ? `${service_id}:${state.next_question}:${this.index()}`
                : false;
        }

        if (!state.current_response) {
            next_button.addClass('disabled');
        }
        else {
            next_button.removeClass('disabled');
        }

        return this;
    }

    $.fn.getPreviousSection = function () {
        const section = this.parent().parent();

        dataLayer.push({
            event: 'return_to_previous_section'
        });

        section.fadeOut(250);

        setTimeout(function () {
            section.prev().fadeIn(250);
            section.remove();
        }, 250);
    }

    $.fn.getNextSection = function (_services, question) {
        let next = true;

        if (this.parent().parent().next().length > 0) {
            next = false;
        }

        dataLayer.push({
            event: 'go_to_next_section',
            service_name: getServiceName(_services[0]),
            service_names: _services.map(getServiceName).join(', ')
        });

        const render_data = {
            services: _services.join(','),
            question: parseInt(question),
            response: state.current_response,
            next: next,
            section: this.parent().parent().attr('class'),

            action: 'arise_pc_get_next_section',
            nonce: arise_pc.nonce
        };

        console.log(render_data);

        const _this = this;

        $.ajax({
            url: arise_pc.ajax_url,
            type: 'POST',
            data: render_data,

            beforeSend: function () {
                console.log('getting next question');

                _this.parent().parent().addClass('loading');
            },

            success: function (response) {
                _this.parent().parent().removeClass('loading');

                state.services = (response.data.services).split(',');
                state.next_question = parseInt(response.data.question);

                console.log(state.services);
                //console.log(next_question);

                _this.parent().parent().fadeOut(250);

                if (next) {
                    setTimeout(function () {
                        _this.parent().parent().parent().append(response.data.section);
                        _this.parent().parent().parent().children().last().fadeIn(250);

                        $('html, body').animate({ scrollTop: _this.parent().parent().parent().offset().top - $('.heading-links').outerHeight() }, 250);
                    }, 250);
                }
                else {
                    setTimeout(function () {
                        _this.parent().parent().next().fadeIn(250);

                        $('html, body').animate({ scrollTop: _this.parent().parent().parent().offset().top - $('.heading-links').outerHeight() }, 250);
                    }, 250);
                }
            },

            complete: function () {
                _this.parent().parent().removeClass('loading');
            }
        });
    }

    $(document).on('click', '.pricing-calculator__answer', function (event) {
        event.preventDefault();

        $(this).toggleAnswer();
    });

    $(document).on('click', '.pricing-calculator__service', function (event) {
        event.preventDefault();

        $(this).toggleService();
    });

    $(document).on('click', '.pc-next', function (event) {
        event.preventDefault();

        if (state.next_question === -1) {
            state.all_services = state.services.slice();
        }

        //state.next_question = parseInt($(this).parent().parent().attr('data-next'));
        state.next_question += 1;

        console.log(state.next_question);

        $(this).getNextSection(state.services, state.next_question);
    });

    $(document).on('click', '.pc-prev', function (event) {
        event.preventDefault();

        state.next_question -= 1;

        console.log(state.next_question);

        $(this).getPreviousSection(state.services);
    });
});